import { useState, useEffect, Fragment } from 'react'
import { Spinner, Input, Button } from 'reactstrap'
import { getFieldChoices } from '../AppObjectField/AppObjectFieldUtils'

export default function SearchFormSelect({ index, field, onChangeFunction, defaultValue }) {
  console.log(`SearchFormSelect rendered: ${field.name} of type ${field.type.name}`, index)
  const [value, setValue] = useState(defaultValue)
  const [choices, setChoices] = useState([])
  const [spinner, setSpinner] = useState(false)

  useEffect(() => {
    async function getChoices() {
      console.log(`SearchFormSelect: retrieving options for ${field.name}`)
      setSpinner(true)
      //const { data } = await window.apolloClient.query({ query: CHOICES, variables: { fieldId: field.id }, fetchPolicy: 'cache-first' })
      const choices = await getFieldChoices(field)
      setSpinner(false)
      setChoices(choices)
    }
    getChoices()
  }, [field])

  function handleChange(event) {
    console.log('SearchFormSelect.handleChange', event)
    const selectedValues = []
    for (let option of event.target.selectedOptions) {
      selectedValues.push(option.value)
    }
    event.selectedValues = selectedValues
    onChangeFunction(event)
    setValue(selectedValues)
  }

  function handleClear() {
    console.log('SearchFormSelect.handleClear')
    const event = { target: { name: 'inputValue' }, selectedValues: [], index: index }
    onChangeFunction(event)
    setValue([])
  }

  let maxLength = 0
  const options = []
  if (choices) {
    for (let choice of choices) {
      options.push(<option key={choice.id} value={choice.id}>{choice.name}</option>)
      if (choice.name.length > maxLength) {
        maxLength = choice.name.length
      }
    }
  }

  if (spinner) {
    return <Spinner size="sm" color="primary" />
  } else {
    return (
      <Fragment>
        <Input
          style={{ maxWidth: '500px'}}
          type="select"
          name="inputValue"
          bsSize="sm"
          onChange={handleChange}
          index={index}
          multiple
          value={value}
        >
          {options}
        </Input >
        <Button color="secondary" size="sm" style={{ marginTop: '5px', marginBottom: '10px' }} onClick={handleClear}>Clear Selections</Button>
      </Fragment>
    )
  }
}